#return
$ = require 'jquery'
require('fancybox')($)
require('malihu-custom-scrollbar-plugin')($)

images_url = '//www.tourtrans.ru/js/online-styles/new/'

router = require './components/router'

if router.nojs()
  return

auth = require './components/auth'

Loader = require './components/loader'
loader = new Loader(images_url + 'loader.gif')
loader.show()
window.loader = loader # global hack to hide from basket

Observer = require './components/observer'
Checkboxes = require './components/checkboxes'

header = require './pages/header'

common = require './pages/common' # common for all page types

# page types
autobusQuotes = require './pages/autobus_quoutes'
SimpleBasket = require './pages/simple_basket'
simpleBasket = new SimpleBasket
basket = require './pages/basket'
orderInfo = require './pages/order_info'

login = require './pages/login'
passwordRecovery = require './pages/password_recovery'
partnerRegistration = require './pages/partner_registration'
personalRegistration = require './pages/personal_registration'
personalPage = require './pages/personal_page'
touristQuestionnaires = require './pages/tourist_questionnaires'

orderList = require './pages/order_list'
bonuses = require './pages/bonuses'
documents = require './pages/documents'
commission = require './pages/commission'

window.alert_orig = window.alert
window.alert = () ->
#  console.log(arguments...)
  if arguments[0] == 'Ваша заявка успешно отправлена'
    if router.site() == 'personal'
      gtag('event', 'заявка на тур отправлена', {'event_category': 'заявка на тур'})

  window.alert_orig(arguments...)

window.confirm_orig = window.confirm
window.confirm = () ->
#  console.log(arguments...)
  window.confirm_orig(arguments...)

$(document).on 'click.fancybox_popup', 'a.fancybox_popup', (e) ->
  e.preventDefault()
  $el = $(e.target)
  $.fancybox.open([
    {
      type: 'iframe',
      href: $el.attr('href'),
      closeBtn: true,
      width: $el.data('width'),
      height: $el.data('height')
    }
  ], {
    padding: 20,
  })


# первичные стили
applyStyles = ->
  # Меняем стили:
  #   1. Общее для всех страниц
  #     - швапка + меню + футер
  #     - чекбоксы
  #     - текстовые поля
  #     - селекты
  #
  #   2. Частное

  loader.show()

  #  $(document).off 'click:fancybox_popup'
  #  $('a.fancybox_popup').click (e) ->

  $('img[src="images/del.gif"]').attr('src', images_url + 'icon_remove.svg').css('width', '24px')

  header.applyLogin()
  header.applyMenu()
  if router.site() == 'online'
    header.applyBanner()

  new Checkboxes

#  if $('.wrapper').length == 0
#    $wrapper = $ '<div/>',
#      class: 'wrapper'
#    $inner = $('body').children()
#    $inner.wrapAll($wrapper)

  common.applyStyles()

  switch router.page()
    when 'login'
      login.applyStyles()
    when 'passwordRecovery'
      passwordRecovery.applyStyles()
    when 'passwordrecovery'
      passwordRecovery.applyStyles()
    when 'PartnerRegistration'
      partnerRegistration.applyStyles()
    when 'PersonalRegistration'
      personalRegistration.applyStyles()
    when 'PersonalPage'
      personalPage.applyStyles()
    when 'TouristQuestionnaires'
      touristQuestionnaires.applyStyles()
    when 'AutobusQuotes'
      if router.site() == 'personal'
        qp = router.queryParams()
        fromSite = qp.tourlistkey != undefined
        forLogin = qp.forlogin != undefined
        if not (fromSite or forLogin)
          window.location.replace $('.nav li.order_list a').attr('href')
#      autobusQuotes.addTabs()
      autobusQuotes.applyStyles()
#      autobusQuotes.addTpl()
#      autobusQuotes.applyFilters()
#      $('#ctl00_generalContent_autobusFilter_TourTypeListPanel').mCustomScrollbar
#        theme: 'dark-thick'
#      $('#ctl00_generalContent_autobusFilter_TourListPanel').mCustomScrollbar
#        theme: 'dark-thick'
    when 'Basket'
      basket.applyStyles()
    when 'SimpleBasket'
      simpleBasket.applyStyles()
    when 'OrderInfo'
      orderInfo.applyStyles()
    when 'OrderList'
      orderList.applyStyles()
    when 'bonuses'
      bonuses.applyStyles()
    when 'documents'
      documents.applyStyles()
    when 'commission'
      commission.applyStyles()

  loader.hide()

# применение стилей повторно к подгруженным элементам
observe = (mutation) ->
  # TODO: хорошо бы оптимизировать и применять только к новым
  new Checkboxes

  $('img[src="images/del.gif"]').attr('src', images_url + 'icon_remove.svg').css('width', '24px')

  switch router.page()
    when 'AutobusQuotes'
      autobusQuotes.applyStyles()
    when 'Basket'
      console.log('online.coffee observe ...', mutation)
      if mutation.type == 'attributes'
        console.log('Поменялся атрибут... пропускаю')
      else
        basket.observe()
    when 'SimpleBasket'
      simpleBasket.observe(mutation)
#    when 'OrderList'
#      orderList.observe()
$ ->
  router.setBodyClasses()
  logged = auth.logged()
  if logged
    username = auth.username()

#  new Observer('ctl00_generalContent_UpdateProgress1', 'hide', observe)
  new Observer('ctl00_generalContent_UpdateProgress1', 'aria-hidden', (mutation)->
    observe(mutation)
    if mutation.oldValue == "false"
      loader.hide()
      console.log 'Прячу лоадер'
    if mutation.oldValue == "true"
      loader.show()
      console.log 'Показываю лоадер'
  )

  applyStyles()

  $(document).on 'submit', '.login-full form', (e) ->
    #console.log('login submit')
    yaCounter10954994.reachGoal(router.site() + 'auth')
  $(document).on 'click', '.login-full a', (e) ->
    if $(this).text() == 'Регистрация'
      #console.log('reg clicked')
      goal = router.site() + 'reg'
      yaCounter10954994.reachGoal(goal)
    if $(this).text() == 'Забыли пароль?'
      #console.log('forgot password clicked')
      goal = router.site() + 'pass'
      yaCounter10954994.reachGoal(goal)
  $(document).on 'submit', '.simple_basket form, .basket form', (e) ->
    console.log 'basket submit'
    yaCounter10954994.reachGoal(router.site() + 'bronok')

$(window).on 'hashchange', ->
  console.log 'Осуществлена навигация в рамках страницы'

  router.setBodyClasses()

  # Какие-то настройки Мастер-Тура меняют нуберацию и кол-во табов
  switch router.page()
    when 'OrderList'
      orderList.applyStyles()
#      $('#__tab_ctl00_generalContent_TabContainer1_TabPanel1').click() # тестовый Мастер
    # Бонусная программа + Начисленные баллы
    when 'bonuses'
      bonuses.applyStyles()
      console.log 'bon'
#      $('#__tab_ctl00_generalContent_TabContainer1_TabPanel2').click() # тестовый Мастер
#      $('#ctl00_generalContent_TabContainer1_TabPanel6_tab').click() # актуальный Мастер
    # Комиссия
    when 'commission'
      commission.applyStyles()
#      $('#ctl00_generalContent_TabContainer1_TabPanel7_tab').click() # актуальный Мастер
    # Договоры и отчеты
    when 'documents'
      documents.applyStyles()
      console.log 'docs'
#      $('#__tab_ctl00_generalContent_TabContainer1_TabPanel3').click() # тестовый Мастер
#      $('#ctl00_generalContent_TabContainer1_TabPanel3_tab').click() # актуальный Мастер
